import "./App.css";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
// import { NotificationProvider } from "./container/NotificationContext";
import { NotificationProvider } from './components/layout/notificationContext'
import LoginForm from "./container/LoginForm";
import Layout from "./components/layout/Layout";
import { Toaster } from "react-hot-toast";
import Home from "./container/home/home";
import Courts from "./container/courts/courts";
import Sports from "./container/sports/sports";
import UserList from "./container/users/users";
import ChangePassword from "./container/changePassword/changePassword";
import CMS from "./container/cms/cms";
import Profile from "./container/profile/profile";
import Bookings from "./container/bookings/bookings";
import Notifications from "./container/notifications/notifications";
import Api from "./container/api/api";
import Settings from "./container/settings/settings";
import Transactions from "./container/transactions/transactions";
import Reports from "./container/reports/Reports";
import GameReportDetailsPage from "./container/reports/game/GameReportDetails";
import UserReportDetailsPage from "./container/reports/user/UserReportDetails";
import ChatReportDetailsPage from "./container/reports/chat/ChatReportDetails";
import AdminNotifications from "./container/adminNotifications/AdminNotifications";

function App() {
  return (
    // <NotificationProvider>
      <Router>
        <Toaster />
        <Routes>
          <Route path="/login" element={<LoginForm />} />
          <Route element={<Layout />}>
            <Route path="/dashboard" element={<Home />} />
            <Route path="courts" element={<Courts />} />
            <Route path="sports" element={<Sports />} />
            {/* <Route path="game" element={<Game />} /> */}
            <Route path="user-list" element={<UserList />} />
            <Route path="transactions" element={<Transactions/>} />
            <Route path="change-password" element={<ChangePassword />} />
            <Route path="content-management-system" element={<CMS/>}/>
            <Route path="profile" element={<Profile/>} />
            {/* <Route path="bookings" element={<Bookings/>}/> */}
            <Route path="push-notifications" element={<Notifications/>}/>
            <Route path="api-management" element={<Api/>}/>
            <Route path="settings" element={<Settings/>}/>
            <Route path="reports" element={<Reports/>}/>
            <Route path="game-report-details" element={<GameReportDetailsPage/>} />
            <Route path="user-report-details" element={<UserReportDetailsPage/>} />
            <Route path="chat-report-details" element={<ChatReportDetailsPage/>} />
            <Route path="notifications" element={<AdminNotifications/>}/>
          </Route>
          <Route path="*" element={<LoginForm />} />
        </Routes>
        {/* <Routes>
          <Route path="/dashboard" element={<DashboardLayout />} />
          <Route path="*" element={<LoginForm />} />
        </Routes> */}
      </Router>
    // </NotificationProvider>
  );
}

export default App;
